// Send Sendbird Multi Message
export const SEND_SENDBIRD_BATCH_MESSAGE_REQUEST = 'SEND_SENDBIRD_BATCH_MESSAGE_REQUEST';
export const SEND_SENDBIRD_BATCH_MESSAGE_DONE = 'SEND_SENDBIRD_BATCH_MESSAGE_DONE';
export const SEND_SENDBIRD_BATCH_MESSAGE_FAILED = 'SEND_SENDBIRD_BATCH_MESSAGE_FAILED';
export const SEND_SENDBIRD_BATCH_MESSAGE_RESET = 'SEND_SENDBIRD_BATCH_MESSAGE_RESET';